import { FieldValues, UseFormGetValues } from 'react-hook-form'

const getValuesByInstanceId = new Map<string, UseFormGetValues<FieldValues>>()

export const registerFormAncestryGetValues = (
  instanceId: string,
  getValues: UseFormGetValues<FieldValues>
): void => {
  getValuesByInstanceId.set(instanceId, getValues)
}

export const unregisterFormAncestryGetValues = (instanceId: string): void => {
  getValuesByInstanceId.delete(instanceId)
}

export const getFormAncestryGetValues = (
  instanceId: string
): UseFormGetValues<FieldValues> | undefined =>
  getValuesByInstanceId.get(instanceId)
